var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAscend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.394 10.938a.6.6 0 00-.788.906l.788-.905zM5 14l-.394.453A.6.6 0 005.6 14H5zm.6-12a.6.6 0 00-1.2 0h1.2zm-3.994 9.844l3 2.609.788-.906-3-2.609-.788.906zM5.6 14V2H4.4v12h1.2z",
    fill: "#262A33",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.606 5.061a.6.6 0 00.788-.905l-.788.905zM11 2l.394-.453A.6.6 0 0010.4 2h.6zm-.6 12a.6.6 0 101.2 0h-1.2zm3.994-9.844l-3-2.609-.788.906 3 2.608.788-.905zM10.4 2v12h1.2V2h-1.2z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/ascend.c8b2a3a7.svg";
export { SvgAscend as ReactComponent };